import React from 'react';
import PropTypes from 'prop-types';

export default function StarIcon({ size, color, ...rest }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 15" {...rest}>
      <polygon
        fill={color}
        points="8 0 10.349 5.125 16 5.752 11.8 9.546 12.944 15.059 8 12.278 3.056 15.059 4.2 9.546 0 5.752 5.651 5.125"
      />
    </svg>
  );
}

StarIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

StarIcon.defaultProps = {
  size: 15,
  color: '#000',
};
